var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchDeviceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6764 3.52941C9.20515 3.52941 8.01243 4.72771 8.01243 6.20588C8.01243 7.68406 9.20515 8.88235 10.6764 8.88235C12.1477 8.88235 13.3405 7.68406 13.3405 6.20588C13.3405 4.72771 12.1477 3.52941 10.6764 3.52941ZM6.49014 6.20588C6.49014 3.88303 8.36439 2 10.6764 2C12.9885 2 14.8628 3.88303 14.8628 6.20588C14.8628 7.09103 14.5906 7.91232 14.1257 8.58985L16.1621 10.6357L15.0857 11.7172L13.0493 9.6713C12.3749 10.1383 11.5575 10.4118 10.6764 10.4118C8.36439 10.4118 6.49014 8.52875 6.49014 6.20588ZM1.16211 2.76471H4.96784V4.29412H1.16211V2.76471ZM1.16211 8.11765H4.96784V9.64706H1.16211V8.11765ZM14.8628 13.4706V15H1.16211V13.4706H14.8628Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDeviceIcon);
export default __webpack_public_path__ + "static/media/searchDeviceIcon.0fe06260.svg";
export { ForwardRef as ReactComponent };